import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import { useAuth } from '../utils/AuthContext';

const Contact = ({ onClose, mode = 'overview' }) => {
  const { user } = useAuth();
  const [info, setInfo] = useState({
    name: '',
    phone: '',
    supportEmail: ''
  });
  const [fromEmail, setFromEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailStatusLoading, setEmailStatusLoading] = useState(mode === 'email');
  const [statusMessage, setStatusMessage] = useState('');
  const [error, setError] = useState('');
  const [emailStatus, setEmailStatus] = useState({
    configured: false,
    verified: false,
    supportEmail: ''
  });

  useEffect(() => {
    const load = async () => {
      setEmailStatusLoading(mode === 'email');

      try {
        const requests = [api.get('/admin/public')];
        if (mode === 'email') {
          requests.push(api.get('/support/email-status'));
        }

        const results = await Promise.allSettled(requests);
        const infoResult = results[0];
        const emailStatusResult = results[1];

        if (infoResult?.status === 'fulfilled' && infoResult.value.data?.info) {
          setInfo(infoResult.value.data.info);
        }

        if (emailStatusResult?.status === 'fulfilled' && emailStatusResult.value.data?.status) {
          setEmailStatus(emailStatusResult.value.data.status);
        }
      } catch (_error) {
        setInfo((prev) => prev);
      } finally {
        setEmailStatusLoading(false);
      }
    };

    load();
  }, [mode]);

  useEffect(() => {
    setFromEmail(user?.email || '');
  }, [user]);

  const submitSupportEmail = async () => {
    if (!emailStatus.configured) {
      setError('SMTP тохируулаагүй тул жинхэнэ майл илгээх боломжгүй байна');
      return;
    }

    setLoading(true);
    setError('');
    setStatusMessage('');

    try {
      const response = await api.post('/support/email', {
        fromEmail,
        message
      });
      setStatusMessage(response.data?.message || 'Майл амжилттай илгээгдлээ');
      setMessage('');
    } catch (requestError) {
      const firstValidationError = requestError.response?.data?.errors?.[0]?.message;
      setError(firstValidationError || requestError.response?.data?.message || 'Майл илгээж чадсангүй');
    } finally {
      setLoading(false);
    }
  };

  const renderPhoneMode = () => (
    <div
      className="form"
      style={{
        width: '100%',
        minWidth: 0,
        justifyItems: 'center',
        textAlign: 'center',
        gap: 14,
        boxSizing: 'border-box'
      }}
    >
      <div style={{ fontSize: 14, opacity: 0.8 }}>Залгах дугаар</div>
      <div style={{ fontSize: 32, fontWeight: 800, letterSpacing: 0.5 }}>{info.phone || '-'}</div>
      <button onClick={onClose}>Хаах</button>
    </div>
  );

  const renderEmailMode = () => (
    <div className="form" style={{ width: '100%', minWidth: 0, boxSizing: 'border-box' }}>
      <div style={{ fontWeight: 700 }}>Admin и-мэйл</div>
      <div style={{ padding: '10px 12px', borderRadius: 10, background: 'rgba(148, 163, 184, 0.12)' }}>
        {emailStatus.supportEmail || info.supportEmail || '-'}
      </div>
      {(emailStatusLoading || !emailStatus.configured || !emailStatus.verified) && (
        <div
          style={{
            padding: '10px 12px',
            borderRadius: 10,
            background: emailStatusLoading
              ? 'rgba(148, 163, 184, 0.12)'
              : 'rgba(239, 68, 68, 0.12)',
            color: emailStatusLoading ? '#334155' : '#b91c1c',
            fontSize: 14
          }}
        >
          {emailStatusLoading
            ? 'И-мэйл илгээх тохиргоог шалгаж байна...'
            : !emailStatus.configured
              ? 'SMTP тохируулаагүй байна. Одоо энэ хэсгээс жинхэнэ майл илгээх боломжгүй.'
              : 'SMTP тохиргоо олдсон ч сервер баталгаажуулж чадсангүй. Илгээх оролдлого хийх боломжтой.'}
        </div>
      )}
      <input
        value={fromEmail}
        onChange={(event) => setFromEmail(event.target.value)}
        placeholder="Таны и-мэйл"
        type="email"
      />
      <textarea
        value={message}
        onChange={(event) => setMessage(event.target.value)}
        placeholder="Майлын утга"
        rows={6}
      />
      <div style={{ display: 'flex', gap: 8 }}>
        <button type="button" disabled={loading || emailStatusLoading || !emailStatus.configured} onClick={submitSupportEmail}>
          {loading ? 'Илгээж байна...' : 'Илгээх'}
        </button>
        <button type="button" onClick={onClose}>Хаах</button>
      </div>
      {error && <p className="error">{error}</p>}
      {statusMessage && <p className="success">{statusMessage}</p>}
    </div>
  );

  const renderOverview = () => (
    <div className="form">
      <div>Нэр: {info.name}</div>
      <div>Утас: {info.phone || '-'}</div>
      <div>И-мэйл: {info.supportEmail || '-'}</div>
      <button onClick={onClose}>Хаах</button>
    </div>
  );

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal"
        style={{
          width: mode === 'email' ? 'min(640px, calc(100vw - 40px))' : 'min(460px, calc(100vw - 40px))',
          maxWidth: mode === 'email' ? 640 : 460
        }}
        onClick={(event) => event.stopPropagation()}
      >
        <h3>{mode === 'phone' ? 'Залгах' : mode === 'email' ? 'Майл' : 'Холбоо барих'}</h3>
        {mode === 'phone' ? renderPhoneMode() : mode === 'email' ? renderEmailMode() : renderOverview()}
      </div>
    </div>
  );
};

export default Contact;
